angular.module('autoremind.queries.services', [])
    .factory('adminQueryService', ['$http', '$enhancedHttp',
    function ($http, $enhancedHttp) {
        var adminQueryService = {};
        adminQueryService.getQueries = function () {
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/admin/queries/'
            });
        };
        /*
        adminQueryService.getQuery = function (queryName) {
            return $http( {
                method: 'GET',
                headers : {'Content-Type':'application/json'},
                url: '/servlets/admin/queries/' + queryName + '/'
            });
        };
        */
        adminQueryService.executeQuery = function (queryName, parameters) {
            return $enhancedHttp({
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                url: '/servlets/admin/queries/' + queryName + '/',
                data: { "parameters": parameters }
            });
        };
        return adminQueryService;
    }]);
//# sourceMappingURL=queries.services.js.map